import React from "react";

const AddressCard = () => {
  return (
    <div>
      <div className="space-y-3 space-x-3">
        <p className="font-semibold">Saqib Arshad</p>
        <p>Lahore, Qasur Pura Bazar, 54000</p>
        <div className="space-y-3">
          <p className="font-semibold">Phone Number:</p>
          <p>0321-1234567</p>
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
